import { Badge } from '@bbpos/ui';
import { STATUS_BADGE } from './constants';
import type { BookingStatus } from './types';

export interface BookingStatusBadgeProps {
  status: BookingStatus;
  size?: 'sm' | 'md';
}

export function BookingStatusBadge({ status, size = 'sm' }: BookingStatusBadgeProps) {
  const meta = STATUS_BADGE[status] ?? STATUS_BADGE.PENDING;
  return (
    <Badge variant={meta.variant} size={size}>
      <span className="flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-current" />
        {meta.label}
      </span>
    </Badge>
  );
}
